import React from 'react';
import { useTranslation } from 'react-i18next';
import './ImproveWithAiButton.scss';
import { ReactComponent as AIIcon } from '../../../../assets/icons/u_AI.svg';
import { IASuggestionResponse } from '../../../../api/accordanceApi';
import { IAImproveText } from '../../../ProjectDetail/ProjectTabs/Accordances/NewAccordanceForm/IAImproveText/IAImproveText';
import { isGibberishText } from '../../../../services/gibberishDetection';

type Props = {
  disabled?: boolean;
  handleClick: () => void;
  customText?: string;
  isLoading?: boolean;
  IAResponse?: IASuggestionResponse | null;
  IAErrorRequest?: string | null;
  suggestedText?: string;
  textToValidate?: string;
  onUse: () => void;
  onDiscard: () => void;
  onRetry: () => void;
  onCancel: () => void;
};

const MIN_LENGTH_GET_MORE_TEXT = 20;
const MIN_LENGTH_CAN_ADJUST = 60;

const ImproveWithAIButton = ({
  disabled,
  handleClick,
  customText,
  isLoading,
  IAResponse,
  IAErrorRequest,
  suggestedText,
  textToValidate,
  onUse,
  onDiscard,
  onRetry,
  onCancel }: Props) => {
  const { t } = useTranslation();
  const hasInconsistentText = !disabled && isGibberishText(textToValidate);
  const isButtonDisabled = Boolean(disabled || hasInconsistentText);

  const getHelperText = () => {
    const textLength = textToValidate?.length ?? 0;

    if (textLength < MIN_LENGTH_GET_MORE_TEXT) {
      return t('ai_default_text_wording');
    }

    if (textLength < MIN_LENGTH_CAN_ADJUST) {
      return t('ai_more_text_needed');
    }

    return t('ai_can_adjust_wording');
  };

  return IAResponse ? (
    <IAImproveText
      suggestedText={suggestedText}
      onUse={onUse}
      onDiscard={onDiscard}
    />
  ) : IAErrorRequest ? (
    <div>
      <div className="improve-with-ai-button__error">{IAErrorRequest}</div>
      <section className="flex">
        <button
          className={`btn btn-primary small`}
          disabled={isButtonDisabled}
          onClick={onRetry}
          type="button"
        >{t('retry_message')}</button>
        <button
          className={`btn btn-primary-outlined small`}
          disabled={isButtonDisabled}
          onClick={onCancel}
          type="button"
        >{t('cancel')}</button>
      </section>
    </div>
  ) : (
    <div className='content-review-wording'>
      {!hasInconsistentText ? (
        <p>{getHelperText()}</p>
      ) : (
        <p className="improve-with-ai-button__not_interpretable">{t('ai_input_not_interpretable')}</p>
      )}

      <button
        className={`improve-with-ai-button ${isButtonDisabled ? 'disabled' : isLoading ? 'loading' : 'active'}`}
        disabled={isButtonDisabled}
        onClick={handleClick}
        type="button"
      >
        {isLoading ? <span className="loading-spinner"></span> : <AIIcon className="improve-with-ai-button__icon" />}
        <p className={"improve-with-ai-button__text" + (isLoading ? " loading" : "")}>{customText || t('review_wording').toUpperCase()}</p>
      </button>
    </div>

  );
};

export default ImproveWithAIButton;
